import React from 'react';
import './EmptyState.css';

export interface EmptyStateProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  description?: React.ReactNode;
  icon?: React.ReactNode;
  action?: React.ReactNode;
  compact?: boolean;
  className?: string;
  role?: string;
  'aria-live'?: 'polite' | 'assertive' | 'off';
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  description,
  icon,
  action,
  compact = false,
  className = '',
  role = 'status',
  'aria-live': ariaLive = 'polite',
  ...props
}) => {
  const compactClass = compact ? 'ui-empty-state-compact' : '';
  const combinedClassName = ['ui-empty-state', compactClass, className]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={combinedClassName} role={role} aria-live={ariaLive} {...props}>
      {icon && <div className="ui-empty-icon">{icon}</div>}
      <div className="ui-empty-title">{title}</div>
      {description && <div className="ui-empty-description">{description}</div>}
      {action && <div className="ui-empty-action">{action}</div>}
    </div>
  );
};

export default EmptyState;
